import * as React from 'react';
import { computed, observable } from 'mobx';
import { observer } from 'mobx-react';

import { OfficeFormView } from './office-form.view';
import { TransportCompanyOfficeListDataService } from './office.data';
import { EntitySchemaDataService } from 'src/app/general/entity-schemas/entity-schema.data';
import { ObjectUtils } from 'src/core/utils/object';

interface Props extends ComponentViewProps<TransportCompanyOfficeItem> {
	mode: ControlMode;
	onModeChanged: (mode: ControlMode) => void;
	contextService: any;
	supplier: SupplierItem;
	dataService: TransportCompanyOfficeListDataService;
}

interface State {
	schema?: JsonSchema;
}

@observer
export class OfficeFormController extends React.Component<Props, State> {
	@observable
	office: TransportCompanyOfficeItem;

	constructor(props: Readonly<Props>) {
		super(props);

		this.initializeHourRange(props.model);
		this.office = this.props.model;

		if (this.props.dataService.items.find(o => o == this.office) == null) {
			this.props.dataService.items.push(this.office);
		}

		this.state = {};
	}

	componentDidMount() {
		this.loadSchema();
	}

	componentWillReceiveProps(nextProps: Readonly<Props>) {
		this.initializeHourRange(nextProps.model);
		const { model } = nextProps;
		if (model) {
			this.office = model;
		}
	}

	private initializeHourRange(model: TransportCompanyOfficeItem): void {
		if (model == null) {
			return;
		}

		if (Object.getOwnPropertyNames(model.dynamicProperties).find(x => x == 'openingHour') == null) {
			model.dynamicProperties['openingHour'] = null;
		}
		if (Object.getOwnPropertyNames(model.dynamicProperties).find(x => x == 'closingHour') == null) {
			model.dynamicProperties['closingHour'] = null;
		}
	}

	private async loadSchema(): Promise<void> {
		const entitySchemaService = EntitySchemaDataService.make();

		entitySchemaService.addFilter('name', 'eq', 'TransportCompanyOffice');
		entitySchemaService.addSorting('name', 'asc', true);
		entitySchemaService.pageSize = 1;

		const entitySchemas = await entitySchemaService.load(query => query);
		const schema = ObjectUtils.toObject<JsonSchema>(entitySchemas[0].schema);
		this.setState({ schema: schema });
	}

	@computed
	get title() {
		if (this.props.model && this.props.model.title) {
			return this.props.model.title;
		}
		return '';
	}

	addContact = (): void => {
		if (this.props.model != null) {
			this.props.model.dynamicProperties['contacts'].push({});
			this.initializeHourRange(this.props.model);
		}
	};


	render() {
		const { schema } = this.state;
		if (this.office == null || schema == null) {
			return null;
		}

		return (
			<OfficeFormView
				model={this.office}
				title={this.title}
				mode={this.props.mode}
				setBusy={this.props.setBusy}
				contextService={this.props.contextService}
				schema={schema}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/products/office/office-form.controller.tsx